/**
 * OfflineBanner — AC6.
 *
 * Renders a persistent warning banner when `navigator.onLine` is false.
 * Auto-dismisses when the browser fires the 'online' event.
 * Uses design.md tokens: text-warning, bg-bg-warm, border-line-2.
 */
import { type ReactElement, useEffect, useState } from 'react';

export function OfflineBanner(): ReactElement {
  const [offline, setOffline] = useState(!navigator.onLine);

  useEffect(() => {
    function onOnline() {
      setOffline(false);
    }
    function onOffline() {
      setOffline(true);
    }

    window.addEventListener('online', onOnline);
    window.addEventListener('offline', onOffline);

    return () => {
      window.removeEventListener('online', onOnline);
      window.removeEventListener('offline', onOffline);
    };
  }, []);

  if (!offline) return <></>;

  return (
    <div
      role="status"
      aria-live="polite"
      className="bg-bg-warm border-b border-line-2 px-4 py-2 text-center font-sans text-small text-warning"
    >
      You are currently offline. Some features may be unavailable until your connection is restored.
    </div>
  );
}
